import type { FC } from 'react'
import PriorAuthorizationList from './PriorAuthorizationList'
import { PatientUser } from '~/shared/types'

interface PriorAuthorizationProps {
  patient: PatientUser
}

/** Design-refresh Prior Authorization tab. */
const PriorAuthorization: FC<PriorAuthorizationProps> = props => {
  return <PriorAuthorizationList person={props.patient.person} />
}

export default PriorAuthorization
